import { dongpilTalkio, theisTalkio, woongTalkio } from "server/check-super-admin-access";
import { SiteConfig } from "../../types";
export const _config: SiteConfig = {
  isDefault: false,
  enableStripeBilling: false,
  serviceName: "Talkio AI",
  publicUrl: "https://ko.talkio.ai",
  appLogoPath: "/partner/korea/logo.png",
  appLogoHeight: "5px",
  landingLogoPath: "/partner/korea/logo.png",
  landingLogoHeight: "25px",
  favicon: "/favicon.png",
  showTidio: false,
  showLanguageGuides: true,
  adminEmail: "help@talkio.co.kr",
  reviewLink: "https://senja.io/p/talkio/r/9XyUN8",
  overrideLanding: true,
  superAdminIds: [dongpilTalkio, woongTalkio, theisTalkio],
  authErrorPath: "https://kr.talkio.ai/hub/auth/logout/",
  authSignInPath: "https://kr.talkio.ai/hub/auth/login/",
  authSessionDurationHours: 2,
  supportLink: "https://kr.talkio.ai/hub/user/help_reg/",
  hideSignUpLink: true,
  hidePrivacyTosSection: true,
  hideDiscordLink: true,
  uiLanguage: "ko-KR",
  enableRecordingPlayback: true,
  settingsShowLiveFeedback: false,
  disableCategoryRecommendations: true,
  pwaIcons: [
    {
      src: "/icons/icon-192x192.png",
      type: "image/png",
      sizes: "192x192",
    },
    {
      src: "/icons/icon-256x256.png",
      type: "image/png",
      sizes: "256x256",
    },
    {
      src: "/icons/icon-512x512.png",
      type: "image/png",
      sizes: "512x512",
    },
  ],
  siteColors: {
    special: {
      homeView4BackgroundColor: "#4193F1",
      homeView4ButtonBackgroundColor: "#0D67C7",
      homeView4TextColor: "white",
    },
  },
};
